// src/Home.js
import React from 'react';
import { Link } from 'react-router-dom';
import './styles/Home.css';
import background from './assets/background.png';
import logo from './assets/logo.png';
import { FaAndroid, FaWhatsapp, FaEnvelope } from 'react-icons/fa';

const Home = () => {
  return (
    <div
      className="home-container"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="navbar">
        <img src={logo} alt="Logo" className="logo" />
        <div className="hamburger-menu">
          <Link to="/login">Login</Link>
          <Link to="/signup">Sign Up</Link>
        </div>
      </div>

      <h1 className="welcome-title">Welcome To Smart Trading Pro EA</h1>

      <div className="main-box">
        <p className="main-message">
          THIS IS YOUR OPPORTUNITY 🚀 HURRY UP AND HOST YOUR FIRST EA WITH
          SMART TRADING PRO EA
        </p>
        <Link to="/signup" className="get-started-btn">
          GET STARTED
        </Link>
      </div>

      <div className="contact-box">
        <a
          href="https://smart-trading-pro.space/download-app"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaAndroid size={28} />
        </a>
        <a
          href="https://wa.me/27723356130"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp size={28} />
        </a>
        <a href="mailto:greedytrader012@gmail.com">
          <FaEnvelope size={28} />
        </a>
      </div>

      <div className="footer">
        <p>FOUNDER OF SMART TRADING PRO EA: MALATJI TJATJI</p>
        <p>FEATURING: TACSOUL (MOHALE)</p>
        <p>FEATURING: TEMOSHO FX (TEMOSHO)</p>
        <p>COPYRIGHT ©️ 2025</p>
        <p className="motivation">
          “The market rewards those who take smart risks. Don't wait. Start
          building your trading empire today.” 💼📈
        </p>
      </div>
    </div>
  );
};

export default Home;